import { fetchGetText, rootApi } from '../helpers/api';

const graphApi = `${rootApi}/stations/findRealtimeFields`;

export const findRealtimeFields = data => fetchGetText(`${graphApi}/${data}`);